import React, { useState, useEffect } from 'react';
import { Radio, Slider, Row, Col, Typography, Switch } from 'antd';
import * as THREE from 'three';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

export default function VideoEditor({
  selectedModel,
  selectedModelProps,
  dispatchChangeModels,
  setSelectedModelProps,
}) {
  const threeObj = selectedModel.props?.asset?.ref?.current;
  if (!threeObj) return <></>;
  const [loop, setLoop] = useState<any>(threeObj?.loop ?? true);
  const [autoPlay, setAutoPlay] = useState<any>(threeObj?.autoPlay ?? true);

  useEffect(() => {
    setLoop(() => threeObj?.loop ?? true);
    setAutoPlay(() => threeObj?.autoPlay ?? true);
  }, [selectedModel]);

  function onChange(val, event) {
    if (event === 'loop') {
      setLoop(() => val);
    } else {
      setAutoPlay(() => val);
    }
    threeObj[event] = val;
  }

  return (
    <div style={{ display: 'flex', gap: '20px', flexDirection: 'column' }}>
      <Row>
        <Col span={24}>
          <span>Use Loop Video</span>
        </Col>
        <Col span={24}>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={loop}
            onChange={(val) => {
              onChange(val, 'loop');
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <span>Use Auto Play Video</span>
        </Col>
        <Col span={24}>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={autoPlay}
            onChange={(val) => {
              onChange(val, 'autoPlay');
            }}
          />
        </Col>
      </Row>
    </div>
  );
}
